module.exports = __webpack_public_path__ + "img/DUAL MAGAZINE LOADERUNLOADER(CE Type).066db268.jpg";